import { render, staticRenderFns } from "./NewYearLogoFlip.vue?vue&type=template&id=895272fa&scoped=true"
import script from "./NewYearLogoFlip.vue?vue&type=script&lang=js"
export * from "./NewYearLogoFlip.vue?vue&type=script&lang=js"
import style0 from "./NewYearLogoFlip.vue?vue&type=style&index=0&id=895272fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895272fa",
  null
  
)

export default component.exports